import { Component } from '@angular/core';

@Component({
	selector: 'app-site-ebus',
	templateUrl: './site-ebus.component.html',
})
export class SiteEbusComponent {

}
